import Api from '@/services/Api'
import axios from 'axios'

export default {
  getExportProcesses () {
   return Api().get("/export-processes");
  },
  updateExportProcess (params) {
    return Api().put("/export-processes",params);
  },
  addExportProcess (params) {
    return Api().post("/export-processes",params);
  },
  getExportProcess (params) {
    return Api().get("/export-processes/"+params);
  },
  deleteExportProcess (params) {
    return Api().delete("/export-processes/"+params);
  },
  addExportProcessConfiguration (params) {
    return Api().post("/export-process-configurations/",params);
  },
  updateExportProcessConfiguration (params) {
    return Api().put("/export-process-configurations/",params);
  },
  getExportProcessConfiguration () {
    return Api().get("/export-process-configurations");
  },
}



// WEBPACK FOOTER //
// ./src/services/ExportProcessService.js